import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { handleSubmitQueryThunk } from '../thunks/AILegalMessageThunks';

interface AIMessagesState {
  loading: boolean;
  error: string | null;
}

const initialState: AIMessagesState = {
  loading: false,
  error: null
};

const aiMessagesSlice = createSlice({
  name: 'aiMessages',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(handleSubmitQueryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(handleSubmitQueryThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(handleSubmitQueryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'An error occurred';
      });
  }
});

export default aiMessagesSlice.reducer; 